import Vue from 'vue'
import App from './App.vue'
// import CalenderModulRequired from './components/CalenderModulRequired.vue'

import VueShowdown from 'vue-showdown'
import { ProgressPlugin, ModalPlugin, BootstrapVue } from 'bootstrap-vue'

import 'tippy.js/dist/tippy.css'
import 'bootstrap/dist/css/bootstrap.css'

Vue.config.productionTip = false
Vue.use(ProgressPlugin)
Vue.use(ModalPlugin)
Vue.use(BootstrapVue)
Vue.use(VueShowdown)


// Array.from(document.getElementsByClassName('desiredDate')).forEach(element => {
//   new Vue({
//     render: h => h(CalenderModulRequired),
//   }).$mount(element)
// });


new Vue({
  render: h => h(App),
}).$mount('#app')




